module.exports = __webpack_public_path__ + "static/img/bg_banner1.d5a4cb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_banner1.png
// module id = ojXE
// module chunks = 1